import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { httpClient } from '../../../api/httpClient';
import { urlListarAccesoriosMotos } from '../api/urls';

const styles = {
    cardDatosVehiculo: {
        width: '100%',
        height: 'auto',
        marginTop: '15px',
        marginBottom: '20px',
        padding: '18px 20px',
        backgroundColor: '#f2f2f2',
        borderRadius: '4px'
    },
    tituloVehiculo: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#000000'
    },
    subTituloVehiculo: {
        fontSize: '15px',
        fontWeight: 'normal',
        color: '#515253',
        wordBreak: 'break-word'
    },
    pregunta: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#000000'
    },
    customCheckbox: {
        width: '22px',
        height: '22px',
        border: '2px solid #001871',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: '#ffffff'
    },
    customCheckboxChecked: {
        width: '22px',
        height: '22px',
        border: '2px solid #001871',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: '#001871'
    }
};

/**
 * Componente oficial de Datos del Vehículo para Motos.
 * Con validaciones estrictas en caso de que posea accesorios adicionales.
 */
const DatosVehiculoMoto = ({
    datosVehiculo,
    plan,
    idCotizacion,
    idCarrito,
    onModificar,
    poseeAccesorios,
    onChangePoseeAccesorios,
    valorExtras,
    onChangeValorExtras,
    accesoriosSeleccionados,
    onChangeAccesoriosSeleccionados,
    amparoPatrimonial,
    onChangeAmparoPatrimonial,
    erroresValidacion,
    placa: placaProp
}) => {
    const [listaAccesorios, setListaAccesorios] = useState([]);
    const [cargandoAccesorios, setCargandoAccesorios] = useState(false);

    var v = datosVehiculo || {};
    var marca = v.marcaNombre || (v.marca && v.marca.label) || v.marca || 'N/A';
    var modelo = v.modeloNombre || (v.modelo && v.modelo.label) || v.modelo || 'N/A';
    var placa = placaProp || v.placa || 'SIN PLACA';
    var clase = v.tipo || 'MOTO';
    var uso = v.uso || 'PARTICULAR / PASEO';
    var anio = v.anio || 'N/A';
    var numValor = parseFloat(v.valorAsegurado) || 0;
    var valorAseguradoStr = '$' + numValor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var planNombre = (plan && (plan.nombre || plan.tipoPlan)) || 'AIG Moto GO';
    var sucursal = v.sucursalNombre || (v.sucursal && v.sucursal.label) || '';
    
    // Máximo 20% del valor del casco
    var maxExtras = (numValor * 20) / 100;

    useEffect(() => {
        var cargarCatalogoAccesorios = async () => {
            setCargandoAccesorios(true);
            try {
                var res = await httpClient.get(urlListarAccesoriosMotos);
                if (res && res.transaccion && Array.isArray(res.accesorios)) {
                    var opts = res.accesorios.map(function(item) {
                        return {
                            value: item.accCodigoCore,
                            label: item.accNombre
                        };
                    });
                    setListaAccesorios(opts);
                } else {
                    setListaAccesorios([
                        { value: 'ACC_CASCO', label: 'Casco Especial / Certificado' },
                        { value: 'ACC_MALETERO', label: 'Maletero / Baúl Trasero' },
                        { value: 'ACC_ESCAPE', label: 'Tubo de Escape Deportivo' },
                        { value: 'ACC_DEFENSA', label: 'Defensas / Sliders de Protección' },
                        { value: 'ACC_LUCES', label: 'Luces Exploradoras LED' },
                        { value: 'ACC_ALARMA', label: 'Alarma de Proximidad' }
                    ]);
                }
            } catch (err) {
                setListaAccesorios([
                    { value: 'ACC_CASCO', label: 'Casco Especial / Certificado' },
                    { value: 'ACC_MALETERO', label: 'Maletero / Baúl Trasero' },
                    { value: 'ACC_ESCAPE', label: 'Tubo de Escape Deportivo' },
                    { value: 'ACC_DEFENSA', label: 'Defensas / Sliders de Protección' },
                    { value: 'ACC_LUCES', label: 'Luces Exploradoras LED' },
                    { value: 'ACC_ALARMA', label: 'Alarma de Proximidad' }
                ]);
            } finally {
                setCargandoAccesorios(false);
            }
        };
        cargarCatalogoAccesorios();
    }, []);

    var err = erroresValidacion || {};
    var errorAccesorios = err.sinAccesorios;
    var errorValor = err.sinValor;
    var errorLimite = err.superaLimite;

    return (
        <Card className="shadow-sm mb-4">
            <CardBody style={{ padding: '2rem' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 style={{ fontWeight: 'bold', color: '#000000', margin: 0 }}>
                        Datos del Vehículo
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontSize: '15px', color: '#515253', marginRight: '8px', fontWeight: 'bold' }}>
                            Plan:
                        </span>
                        <span className="badge badge-primary" style={{ backgroundColor: '#001871', fontSize: '0.95rem', padding: '6px 14px', borderRadius: '4px' }}>
                            {planNombre}
                        </span>
                    </div>
                </div>

                {/* Caja Gris con Grid Oficial: 3 Arriba y 3 Abajo */}
                <div style={styles.cardDatosVehiculo}>
                    {/* Fila 1: Marca, Modelo, Placa */}
                    <Row className="mb-3">
                        <Col lg={4} md={4} sm={12} className="mb-2 mb-md-0">
                            <Row>
                                <Col xs={4} sm={4} md={4}>
                                    <span style={styles.tituloVehiculo}>Marca:</span>
                                </Col>
                                <Col xs={8} sm={8} md={8}>
                                    <span style={styles.subTituloVehiculo}>{marca}</span>
                                </Col>
                            </Row>
                        </Col>

                        <Col lg={4} md={4} sm={12} className="mb-2 mb-md-0">
                            <Row>
                                <Col xs={4} sm={4} md={4}>
                                    <span style={styles.tituloVehiculo}>Modelo:</span>
                                </Col>
                                <Col xs={8} sm={8} md={8}>
                                    <span style={styles.subTituloVehiculo}>{modelo}</span>
                                </Col>
                            </Row>
                        </Col>

                        <Col lg={4} md={4} sm={12}>
                            <Row>
                                <Col xs={4} sm={4} md={4}>
                                    <span style={styles.tituloVehiculo}>Placa:</span>
                                </Col>
                                <Col xs={8} sm={8} md={8}>
                                    <span style={styles.subTituloVehiculo}>{placa}</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {/* Fila 2: Clase, Uso, Año */}
                    <Row>
                        <Col lg={4} md={4} sm={12} className="mb-2 mb-md-0">
                            <Row>
                                <Col xs={4} sm={4} md={4}>
                                    <span style={styles.tituloVehiculo}>Clase:</span>
                                </Col>
                                <Col xs={8} sm={8} md={8}>
                                    <span style={styles.subTituloVehiculo}>{clase}</span>
                                </Col>
                            </Row>
                        </Col>

                        <Col lg={4} md={4} sm={12} className="mb-2 mb-md-0">
                            <Row>
                                <Col xs={4} sm={4} md={4}>
                                    <span style={styles.tituloVehiculo}>Uso:</span>
                                </Col>
                                <Col xs={8} sm={8} md={8}>
                                    <span style={styles.subTituloVehiculo}>{uso || 'PERSONAL'}</span>
                                </Col>
                            </Row>
                        </Col>

                        <Col lg={4} md={4} sm={12}>
                            <Row>
                                <Col xs={4} sm={4} md={4}>
                                    <span style={styles.tituloVehiculo}>Año:</span>
                                </Col>
                                <Col xs={8} sm={8} md={8}>
                                    <span style={styles.subTituloVehiculo}>{anio}</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>

                {/* Pregunta con Checkbox Nítido de Alto Contraste y Juntos */}
                <div 
                    className="d-flex align-items-center mb-3" 
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => {
                        if (onChangePoseeAccesorios) {
                            onChangePoseeAccesorios(!poseeAccesorios);
                        }
                    }}
                >
                    <label 
                        htmlFor="checkAccesorios" 
                        style={{ ...styles.pregunta, cursor: 'pointer', margin: 0, marginRight: '16px', userSelect: 'none' }}
                    >
                        ¿El Vehículo posee Accesorios Adicionales?
                    </label>
                    <div 
                        id="checkAccesorios"
                        style={poseeAccesorios ? styles.customCheckboxChecked : styles.customCheckbox}
                        title="Marque si el vehículo posee accesorios adicionales"
                    >
                        {poseeAccesorios && (
                            <i className="fa fa-check text-white" style={{ fontSize: '13px' }} aria-hidden="true"></i>
                        )}
                    </div>
                </div>

                {/* Despliegue de Accesorios Adicionales (Multi-Select + Valor con Validaciones) */}
                {poseeAccesorios && (
                    <div className="p-3 mb-4 rounded border" style={{ backgroundColor: '#fcfcfc' }}>
                        <Row className="mb-2">
                            <Col lg={6} md={12} className="mb-3 mb-lg-0">
                                <span style={styles.pregunta}>
                                    Seleccione los accesorios: *
                                </span>
                                <div className="mt-1">
                                    <Select
                                        value={accesoriosSeleccionados}
                                        components={makeAnimated()}
                                        onChange={(val) => {
                                            if (onChangeAccesoriosSeleccionados) {
                                                onChangeAccesoriosSeleccionados(val);
                                            }
                                        }}
                                        options={listaAccesorios}
                                        isLoading={cargandoAccesorios}
                                        isSearchable={true}
                                        isMulti={true}
                                        placeholder="Seleccione los accesorios extra..."
                                    />
                                </div>
                                {errorAccesorios && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> Por favor seleccione al menos un accesorio.
                                    </span>
                                )}
                            </Col>

                            <Col lg={6} md={12}>
                                <span style={styles.pregunta}>
                                    Valor total de accesorios ($): *
                                </span>
                                <div className="mt-1">
                                    <input
                                        type="number"
                                        className={"form-control" + ((errorValor || errorLimite) ? " is-invalid" : "")}
                                        placeholder="Ingrese valor ej: 250.00"
                                        min="1"
                                        max={maxExtras}
                                        step="10"
                                        value={valorExtras}
                                        onChange={(e) => {
                                            if (onChangeValorExtras) {
                                                onChangeValorExtras(e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                                {errorValor && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> Por favor ingrese el valor total de los accesorios.
                                    </span>
                                )}
                                {errorLimite && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> El valor no puede superar el límite del 20% (${maxExtras.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}).
                                    </span>
                                )}
                                <small className="text-muted d-block mt-1">
                                    Máximo 20% del valor del casco (${maxExtras.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                                </small>
                            </Col>
                        </Row>
                    </div>
                )}

                {/* Pregunta Incluir Amparo Patrimonial con Checkbox de Alto Contraste */}
                <div 
                    className="d-flex align-items-center mb-1" 
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => {
                        if (onChangeAmparoPatrimonial) {
                            onChangeAmparoPatrimonial(!amparoPatrimonial);
                        }
                    }}
                >
                    <label 
                        htmlFor="checkAmparoPatrimonial" 
                        style={{ ...styles.pregunta, cursor: 'pointer', margin: 0, marginRight: '16px', userSelect: 'none' }}
                    >
                        Incluir Amparo Patrimonial
                    </label>
                    <div 
                        id="checkAmparoPatrimonial"
                        style={amparoPatrimonial ? styles.customCheckboxChecked : styles.customCheckbox}
                        title="Marque si desea incluir Amparo Patrimonial"
                    >
                        {amparoPatrimonial && (
                            <i className="fa fa-check text-white" style={{ fontSize: '13px' }} aria-hidden="true"></i>
                        )}
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default DatosVehiculoMoto;
